<template>
  <div class="body-wrapper">
    <div class="container-fluid">
      <div class="card card-body">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="d-sm-flex align-items-center justify-space-between">
              <h4 class="fw-semibold fs-4 mb-4 mb-md-0 card-title">{{ (user_name) ? 'Coleta ID#' + this.item_id : '' }}
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">Informações</h4>
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="weight">Código</label>
                    <p type="text">{{ code }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label" for="weight">Responsável no Local</label>
                    <p type="text">{{ responsible }}</p>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="weight">Peso da carga (KG)</label>
                    <p type="text">{{ weight }}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label" for="suitable_date">Data para coletar</label>
                    <p type="text">{{ datePickup }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label" for="user_id">Cliente</label>
                    <p type="text">{{ user_name }}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label" for="address_id">Situação</label>
                    <p type="text">{{ status }}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">CEP</label>
                    <p type="text">{{ zip_code }}</p>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label">Rua (Ex.: Rua das neves)</label>
                    <p type="text">{{ street }}</p>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label">Número</label>
                    <p type="text">{{ street_number }}</p>

                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label">Bairro</label>
                    <p type="text">{{ neighbohood }}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">Cidade</label>
                    <p type="text">{{ city }}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="form-label">Estado</label>
                    <p type="text">{{ state }}</p>
                  </div>
                </div>
                <h4 class="card-title mb-3 mt-4">Transporte</h4>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label" for="respCollection">Responsável por coletar</label>
                    <p type="text">{{ name_truck }}</p>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="rg">RG</label>
                    <p type="text">{{ rg_truck }}</p>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="cpf">CPF</label>
                    <p type="text">{{ cpf_truck }}</p>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Placa do Caminhão</label>
                    <p type="text">{{ license_plate }}</p>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Modelo do Caminhão</label>
                    <p type="text">{{ trucker_model }}</p>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Empresa do responsável</label>
                    <p type="text">{{ entity_truck }}</p>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="form-label" for="plateTruck">Link de rastreio</label>
                    <p type="text">{{ tracker_link }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card card-body">
            <h4 class="card-title mb-3">Anexos</h4>

            <div class="row">
              <div class="col-md-6 col-12">
                <div class="mb-3">
                  <label class="form-label" for="address_id">Nome do Anexo</label>
                  <input class="form-control" type="text" id="formFile" v-model="attach_name"/>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="mb-3">
                  <label for="formFile" class="form-label">Escolha um arquivo</label>
                  <input class="form-control" type="file" id="attachment"  ref="attachment"/>
                </div>
              </div>
              <div class="col-12 mt-2 mb-5">
                <div class="d-md-flex align-items-center">
                  <div class="ms-auto mt-3 mt-md-0">
                    <button type="submit" class="btn btn-primary hstack gap-6" @click="upload">
                      <i class="ti ti-plus fs-4"></i>
                      Adicionar
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <table class="table text-nowrap mb-0 align-middle">
                  <thead class="text-dark fs-4">
                    <tr>
                      <th>
                        <h6 class="fs-4 fw-semibold mb-0">Arquivo</h6>
                      </th>
                      <th>
                        <h6 class="fs-4 fw-semibold mb-0">Data de Criação</h6>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in attachments" :key="item.id">
                      <td>
                        <p class="mb-0 fw-normal">{{ item.name }}</p>
                      </td>
                      <td>
                        <p class="mb-0 fw-normal">{{ formatDate(item.created_at) }}</p>
                      </td>
                      <td>
                        <div class="dropdown dropstart">
                          <a href="javascript:void(0)" class="text-muted" id="dropdownMenuButton"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="ti ti-dots-vertical fs-6"></i>
                          </a>
                          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <li>
                              <a target="-blank" class="dropdown-item d-flex align-items-center gap-3" :href="baseStorage+'/'+item.path">
                                <i class="fs-4 ti ti-eye"></i>Visualizar
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Cookies from 'js-cookie';

export default {
  data() {
    return {
      code: '',
      title: null,
      role: 0,
      datePickup: '',
      responsible: '',
      address_id: 0,
      weight: 0,
      name_truck: '',
      rg_truck: '',
      cpf_truck: '',
      license_plate: '',
      trucker_model: '',
      entity_truck: '',
      tracker_link: '',
      user_name: '',
      user_id: 0,
      zip_code: '',
      street: '',
      street_number: '',
      neighbohood: '',
      city: '',
      state: '',
      attach_name: '',
      status: '',
      list: [],
      listAddress: [],
      listStatus: [],
      attachments: [],
      loadingAddress: true,
      loadingClients: true,
    }
  },
  methods: {
    showAlert(type, msg) {
      var textMsg = "";

      if (msg.message) {
        if (typeof msg.errors === 'object' && msg.errors) {
          for (const key in msg.errors) {
            if (Object.prototype.hasOwnProperty.call(msg.errors, key)) {
              const errorMessages = msg.errors[key];
              textMsg += `${errorMessages.join(', ')}<br>`;
            }
          }
        } else {
          textMsg = `${msg.message}`;
        }
      } else {
        textMsg = `${msg}`;
      }

      this.$swal({
        text: textMsg,
        icon: type,
        confirmButtonText: 'Confirmar',
        html: textMsg
      });
    },

    load() {
      this.$http.get('/pickup/' + this.item_id, {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then(response => {
        this.datePickup = response.data.item.collection_orders.suitable_date.date.split(" ")[0];
        this.responsible = response.data.item.collection_orders.responsible;
        this.weight = response.data.item.collection_orders.weight;
        this.name_truck = response.data.item.truck_drivers.name;
        this.rg_truck = response.data.item.truck_drivers.rg;
        this.cpf_truck = response.data.item.truck_drivers.cpf;
        this.license_plate = response.data.item.truck_drivers.license_plate;
        this.trucker_model = response.data.item.truck_drivers.trucker_model;
        this.entity_truck = response.data.item.truck_drivers.entity_truck;
        this.tracker_link = response.data.item.user_id;
        this.user_id = response.data.item.users.id;
        this.user_name = response.data.item.users.individual.name;

        this.zip_code = response.data.item.collection_orders.address.zip_code;
        this.street = response.data.item.collection_orders.address.street;
        this.street_number = response.data.item.collection_orders.address.street_number;
        this.neighbohood = response.data.item.collection_orders.address.neighbohood;
        this.city = response.data.item.collection_orders.address.city;
        this.state = response.data.item.collection_orders.address.state;

        this.status = response.data.item.status.name;
        this.code = response.data.item.code;
      }).catch(error => {
        console.log(error)
      });
    },
    loadAttachment() {
      this.$http.get('/attachment/' + this.item_id, {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then(response => {
        this.attachments = response.data.items;
      }).catch(error => {
        console.log(error)
      });
    },
    async loadAddress() {
      if (this.user_id == 0) return;

      this.listAddress = [];

      await this.$http.get('/list/address/' + this.user_id, {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then(response => {
        this.listAddress = response.data.items
        this.loadingAddress = false;
      })
    },
    async loadStatus() {
      await this.$http.get('/status', {
        headers: {
          'Authorization': 'Bearer ' + Cookies.get('_token')
        }
      }).then(response => {
        this.listStatus = response.data.items
      })
    },
    upload() {

      var json = {
        name: this.attach_name,
        pickup_id: this.item_id,
        path: this.$refs.attachment.files[0]
      };


      this.$http
        .post('/attachment', json, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": "Bearer " + Cookies.get('_token')
          },
        })
        .then((response) => {
          this.showAlert('success', response.data.message);
          this.loadAttachment();
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.showAlert('error', error.response.data);
          } else {
            this.showAlert('error', '[10] Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento.');
          }
        });
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const formattedDate = `${day}/${month}/${year} às ${hours}:${minutes}`;
      return formattedDate;
    },
  },
  created() {
    this.role = this.$store.state.role;
    this.item_id = this.$route.params.id;
  },
  mounted() {
    this.loadStatus();
    this.load();
    this.loadAddress();
    this.loadAttachment();
  }
}
</script>
